<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->
document.addEventListener("DOMContentLoaded", function () {
  const tabButtons = document.querySelectorAll(".tab-btn");
  const tabItems = document.querySelectorAll(".tab-content-item");

  tabButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      tabButtons.forEach((b) => b.classList.remove("active"));
      tabItems.forEach((item) => item.classList.remove("active"));

      if (btn.id === "tab1") {
        document.querySelector(".tab-content-item.tab2").classList.add("active");
        document.getElementById("tab2").classList.add("active");
      } else {
        document.querySelector(".tab-content-item.tab1").classList.add("active");
        document.getElementById("tab1").classList.add("active");
      }
    });
  });
});
<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

 // Ajouter animation carrousel image

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".yc-split-carousel").forEach(section => {

    const carousel = section.querySelector(".yc-carousel");
    const slides = section.querySelectorAll(".yc-slide");
    const next = section.querySelector(".yc-next");
    const prev = section.querySelector(".yc-prev");

    let index = 0;

    function update() {
      carousel.style.transform = `translateX(-${index * 100}%)`;
      carousel.style.transition = "0.5s ease";
    }

    next.addEventListener("click", () => {
      index = (index + 1) % slides.length;
      update();
    });

    prev.addEventListener("click", () => {
      index = (index - 1 + slides.length) % slides.length;
      update();
    });

  });
});

/* ============================================================================= */
/* BULLES TRANSLUCIDES SOUS-TITRE BANNIERE */
/* Ne s'applique que si la banniere contient encore la phrase CIBLE. */
/* Pour retirer : supprimer tout ce bloc. */
/* ============================================================================= */
(function () {
  var CIBLE = '7 bijoux, 7 tenues, et tout ce qui va avec';
  var MOTS = ['7 bijoux', '7 tenues', 'tout pour \u00eatre parfaite'];

  var st = document.createElement('style');
  st.textContent = '.lgh-bulles{display:flex;flex-wrap:wrap;gap:7px;justify-content:center;align-items:center;text-shadow:none !important;margin:0 auto;max-width:640px}'
    + '.lgh-bulle{display:inline-block;padding:6px 15px;border-radius:50px;'
    + 'font-size:13px;font-weight:500;line-height:1.35;white-space:nowrap;letter-spacing:.01em;'
    + 'color:#fff !important;text-shadow:none !important;'
    + 'background:rgba(234,31,117,.34);'
    + '-webkit-backdrop-filter:blur(16px) saturate(140%);backdrop-filter:blur(16px) saturate(140%);'
    + 'border:1px solid rgba(255,255,255,.38);box-shadow:none !important}'
    + '@media(max-width:600px){.lgh-bulle{font-size:11.5px;padding:5px 12px}.lgh-bulles{gap:6px}}';
  document.head.appendChild(st);

  function normalise(t) { return (t || '').replace(/\s+/g, ' ').trim().toLowerCase(); }

  function poser() {
    var cible = normalise(CIBLE);
    var noeuds = document.querySelectorAll('p, span, div, h2, h3, h4');
    for (var i = 0; i < noeuds.length; i++) {
      var n = noeuds[i];
      if (n.querySelector('.lgh-bulles')) continue;
      if (n.children.length > 1) continue;
      if (normalise(n.textContent) !== cible) continue;
      var box = document.createElement('span');
      box.className = 'lgh-bulles';
      for (var k = 0; k < MOTS.length; k++) {
        var b = document.createElement('span');
        b.className = 'lgh-bulle';
        b.textContent = MOTS[k];
        box.appendChild(b);
      }
      n.textContent = '';
      n.style.textShadow = 'none';
      n.appendChild(box);
      return true;
    }
    return false;
  }

  function lancer() {
    if (poser()) return;
    var essais = 0;
    var t = setInterval(function () { essais++; if (poser() || essais > 12) clearInterval(t); }, 400);
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', lancer); } else { lancer(); }
})();

/* ============================================================================= */
/* POP-UP TEASER NOUVELLE COLLECTION - mise a jour le 22 aout 2026 */
/* Compte a rebours jusqu'au samedi 29 aout 2026 a midi (heure de Paris). */
/* Pour changer la date : modifier la ligne FIN. */
/* Pour changer l'image : modifier la ligne IMG. */
/* Pour retirer la pop-up : supprimer tout ce bloc. */
/* ============================================================================= */
(function () {
  var KEY = 'lgh_popup_nouvelle_co';
  var DELAI = 2500;
  var JOURS = 2;
  var FIN = '2026-08-29T12:00:00+02:00';
  var IMG = 'https://cdn.shopify.com/s/files/1/0986/1893/3587/files/Moi_en_Gr_ce.jpg?v=1787492171';

  var p = window.location.pathname.replace(/\/[a-z]{2}(-[a-z]{2})?$/i, '');
  if (p !== '' && p !== '/') return;

  try {
    var v = localStorage.getItem(KEY);
    if (v === 'never') return;
    if (v && Date.now() < parseInt(v, 10)) return;
  } catch (e) {}

  var css = '.lgp-ov{position:fixed;inset:0;z-index:100000;background:rgba(58,20,40,.55);-webkit-backdrop-filter:blur(4px);backdrop-filter:blur(4px);display:none;align-items:center;justify-content:center;padding:20px;opacity:0;transition:opacity .3s ease}'
    + '.lgp-ov.is-open{display:flex}.lgp-ov.is-visible{opacity:1}'
    + '.lgp-ov *,.lgp-ov *::before,.lgp-ov *::after{box-sizing:border-box}'
    + '.lgp{position:relative;width:min(430px,100%);max-height:min(88vh,760px);border-radius:24px;overflow:hidden;background:#FFE4F5;transform:translateY(18px) scale(.97);transition:transform .32s cubic-bezier(.2,.8,.3,1);display:flex;flex-direction:column}'
    + '.lgp-ov.is-visible .lgp{transform:none}'
    + '.lgp__img{position:relative;flex:1 1 auto;min-height:0}'
    + '.lgp__img img{width:100%;height:100%;object-fit:cover;display:block}'
    + '.lgp__img::after{content:"";position:absolute;inset:0;background:linear-gradient(180deg,rgba(234,31,117,0) 26%,rgba(234,31,117,.6) 58%,rgba(200,15,95,.95) 100%)}'
    + '.lgp__body{position:absolute;left:0;right:0;bottom:0;padding:20px 24px 24px;text-align:center;color:#fff}'
    + '.lgp__eyebrow{display:block;font-size:10.5px;letter-spacing:.2em;text-transform:uppercase;color:#FFE4F5;margin-bottom:8px;font-weight:700}'
    + '.lgp__t{font-size:clamp(21px,5vw,27px);line-height:1.15;margin:0 0 14px;color:#fff}'
    + '.lgp__cd{display:flex;justify-content:center;gap:7px;margin-bottom:14px}'
    + '.lgp__cd div{background:rgba(255,255,255,.22);-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px);border:1px solid rgba(255,255,255,.35);border-radius:14px;min-width:58px;padding:8px 6px}'
    + '.lgp__cd b{display:block;font-size:21px;font-weight:700;color:#fff;line-height:1;font-variant-numeric:tabular-nums}'
    + '.lgp__cd span{display:block;font-size:9px;letter-spacing:.1em;text-transform:uppercase;color:#ffe9f5;margin-top:5px}'
    + '.lgp__date{font-size:13px;color:#ffe9f5;margin:0 0 16px}'
    + '.lgp-ov .lgp__form{display:flex;gap:8px;margin:0}'
    + '.lgp-ov .lgp__mail{flex:1 1 auto;min-width:0;border:1px solid rgba(255,255,255,.6);background:rgba(255,255,255,.92);border-radius:50px;padding:13px 18px;font-size:14px;color:#3a2130}'
    + '.lgp-ov .lgp__send{flex:0 0 auto;background:#fff;color:#EA1F75;border:0;border-radius:50px;padding:13px 22px;font-size:14px;font-weight:700;cursor:pointer;white-space:nowrap}'
    + '.lgp-ov .lgp__send:hover{background:#FFE4F5}'
    + '.lgp-ov button.lgp__later{display:block;margin:12px auto 0;background:none;border:0;color:#ffe9f5;font-size:12.5px;text-decoration:underline;cursor:pointer;padding:4px 8px}'
    + '.lgp-ov button.lgp__later:hover{color:#fff}'
    + '.lgp-ov button.lgp__x{position:absolute;top:12px;right:12px;z-index:2;width:38px;height:38px;border-radius:50%;border:0;background:rgba(255,255,255,.9);color:#EA1F75;font-size:20px;line-height:1;cursor:pointer;display:grid;place-items:center;padding:0}'
    + '.lgp-ov button.lgp__x:hover{background:#fff}'
    + '@media(max-width:480px){.lgp{width:100%;max-height:86vh;border-radius:20px}.lgp__body{padding:16px 18px 20px}.lgp__cd div{min-width:52px}.lgp__cd b{font-size:19px}}'
    + '@media(prefers-reduced-motion:reduce){.lgp-ov,.lgp{transition:none}}';

  var html = '<div class="lgp">'
    + '<button class="lgp__x" type="button" aria-label="Fermer">&times;</button>'
    + '<div class="lgp__img"><img src="' + IMG + '" alt="Lydie, prochaine collection"></div>'
    + '<div class="lgp__body">'
    + '<span class="lgp__eyebrow">Bient\u00f4t</span>'
    + '<h2 class="lgp__t">Une nouvelle collection arrive</h2>'
    + '<div class="lgp__cd">'
    + '<div><b data-j>\u2014</b><span>jours</span></div>'
    + '<div><b data-h>\u2014</b><span>heures</span></div>'
    + '<div><b data-m>\u2014</b><span>min</span></div>'
    + '<div><b data-s>\u2014</b><span>sec</span></div>'
    + '</div>'
    + '<p class="lgp__date">Samedi 29 ao\u00fbt \u00e0 midi</p>'
    + '<form class="lgp__form" method="post" action="/contact#contact_form" accept-charset="UTF-8">'
    + '<input type="hidden" name="form_type" value="customer">'
    + '<input type="hidden" name="utf8" value="\u2713">'
    + '<input type="hidden" name="contact[tags]" value="newsletter,teaser-nouvelle-co">'
    + '<input class="lgp__mail" type="email" name="contact[email]" placeholder="Ton e-mail" required aria-label="Ton e-mail">'
    + '<button class="lgp__send" type="submit">Pr\u00e9viens-moi</button>'
    + '</form>'
    + '<button class="lgp__later" type="button">Ne plus afficher ce message</button>'
    + '</div></div>';

  function build() {
    var st2 = document.createElement('style');
    st2.textContent = css;
    document.head.appendChild(st2);

    var ov = document.createElement('div');
    ov.className = 'lgp-ov';
    ov.setAttribute('role', 'dialog');
    ov.setAttribute('aria-modal', 'true');
    ov.innerHTML = html;
    document.body.appendChild(ov);

    var fin = new Date(FIN).getTime();
    var J = ov.querySelector('[data-j]'), H = ov.querySelector('[data-h]'),
        M = ov.querySelector('[data-m]'), S = ov.querySelector('[data-s]');
    var zone = ov.querySelector('.lgp__cd');

    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tic() {
      var d = fin - Date.now();
      if (d <= 0) { if (zone) zone.style.display = 'none'; return; }
      J.textContent = Math.floor(d / 86400000);
      H.textContent = pad(Math.floor(d % 86400000 / 3600000));
      M.textContent = pad(Math.floor(d % 3600000 / 60000));
      S.textContent = pad(Math.floor(d % 60000 / 1000));
      setTimeout(tic, 1000);
    }
    tic();

    function close(never) {
      ov.classList.remove('is-visible');
      document.body.style.overflow = '';
      setTimeout(function () { ov.classList.remove('is-open'); }, 300);
      try { localStorage.setItem(KEY, never ? 'never' : String(Date.now() + JOURS * 86400000)); } catch (e) {}
    }

    ov.querySelector('.lgp__x').addEventListener('click', function () { close(false); });
    ov.querySelector('.lgp__later').addEventListener('click', function () { close(true); });
    ov.querySelector('.lgp__form').addEventListener('submit', function () {
      try { localStorage.setItem(KEY, 'never'); } catch (e) {}
    });
    ov.addEventListener('click', function (e) { if (e.target === ov) close(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && ov.classList.contains('is-open')) close(false);
    });

    setTimeout(function () {
      ov.classList.add('is-open');
      requestAnimationFrame(function () { ov.classList.add('is-visible'); });
      document.body.style.overflow = 'hidden';
    }, DELAI);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
})();
